module.exports = __webpack_public_path__ + "static/media/austria.18d38187.svg";